import { AnyAction, Store } from 'redux'

import { selectors as compareSelectors } from '@cinch/oxd-redux/compare/src'
import { customEventNames, updateCompareInformation } from '@cinch/oxd-utils/analytics/src'

import { CompareVehicle } from '@cinch/oxd-redux/compare/src/interfaces'
import { AdobeDataLayer } from '@cinch/oxd-utils/analytics/src/types'

type compareInfo = AdobeDataLayer['page']['compareInformation']
type actionType = 'add' | 'remove'

const compareEvent = (type: actionType) => (store: Store, action: AnyAction): Cinch.AnalyticsEvent<compareInfo> => {
  const eventNameMap: Record<string, string> = {
    bar: customEventNames.removeFromCompareBar,
    card: customEventNames.removeFromCompareCard,
  }

  const state = store.getState()
  const { location } = action.meta
  const vehicles = compareSelectors.getVehicles(state)
  const compareInformation: compareInfo = {
    advertIds: vehicles.map((vehicle) => vehicle.id).join('|'),
    count: vehicles.length,
  }

  if (type === 'add') {
    compareInformation.lastAddedVehicleId = (action.payload as CompareVehicle).id
  }

  if (type === 'remove') {
    compareInformation.lastRemovedVehicleId = action.payload
  }

  updateCompareInformation(compareInformation)

  return {
    name: type === 'remove' ? eventNameMap[location] : customEventNames.addToCompare,
    details: compareInformation,
  }
}

export default compareEvent
